// extracted by mini-css-extract-plugin
export var root = "plans-page-module--root--c6a54";